import {createContext, useContext} from "react";

export interface DialogDataContainer {
    show: boolean;
    element: JSX.Element;
    key: string;
    onClose?: (result?: any) => void;
    backDropClose: boolean;
}

export interface DialogContextType {
    dialogs: DialogDataContainer[];
    openDialog: (
        element: JSX.Element,
        onClose?: (result?: any) => void,
        backDropClose?: boolean
    ) => void;
    closeDialog: (result?: any) => void;
}

const initialValue: DialogContextType = {
    dialogs: [],
    openDialog: (
        _element: JSX.Element,
        _onClose?: (result?: any) => void
    ) => {},
    closeDialog: (_result?: any) => {},
};

export const DialogContext = createContext(initialValue);

export const useDialogContext = () => {
    return useContext(DialogContext);
}
